import React, { useCallback } from 'react'

export const useFirebaseData = () => {

  const analyzeDoc = useCallback((doc, docType) => {
    return analyzeFirestoreDoc(doc, docType)
  }, []);

  const getLeafPaths = useCallback((doc, docType) => {
    return get_leafPaths(doc, docType)
  }, []);

  const cleanObject = useCallback((obj, removeList) => {
    return cleanFirestoreObject(obj, removeList)
  }, []);


  return {
    analyzeDoc,
    getLeafPaths,
    cleanObject
  }
}


const get_leafPaths = (obj, path = '', set = new Set()) => {
  if (obj === null || obj === undefined) return;

  if (typeof obj !== 'object') {
    set.add(path);
    return;
  }

  if (Array.isArray(obj)) {
    obj.forEach((v, i) =>
      get_leafPaths(v, `${path}[${i}]`, set)
    );
    return;
  }

  for (const k of Object.keys(obj)) {
    get_leafPaths(obj[k], path ? `${path}.${k}` : k, set);
  }

  return set;
};

const analyzeFirestoreDoc = (doc, docType) => {
  const stats = {
    totalKeys: 0,
    maxDepth: 0,
    arrayCount: 0,
    largeArrays: [],
    largeObjects: [],
    sizeBytes: 0
  };

  const seen = new WeakSet();

  const walk = (node, path = '', depth = 0) => {
    stats.maxDepth = Math.max(stats.maxDepth, depth);

    if (node === null || node === undefined) return;

    if (typeof node === 'object') {
      if (seen.has(node)) return;
      seen.add(node);

      if (Array.isArray(node)) {
        stats.arrayCount++;

        if (node.length > 50) {
          stats.largeArrays.push({
            path,
            length: node.length
          });
        }

        node.forEach((item, i) =>
          walk(item, `${path}[${i}]`, depth + 1)
        );

        return;
      }

      const keys = Object.keys(node);
      stats.totalKeys += keys.length;

      if (keys.length > 200) {
        stats.largeObjects.push({
          path,
          keyCount: keys.length
        });
      }

      for (const key of keys) {
        walk(node[key], path ? `${path}.${key}` : key, depth + 1);
      }
    }
  };

  walk(doc);

  stats.sizeBytes = new Blob([JSON.stringify(doc)]).size;

  console.log('stats', docType, stats)

  return stats;
};

const cleanFirestoreObject = (obj, removeList = []) => {
  const removeSet = new Set(removeList);

  const clean = (value, path = '') => {
    if (_.isArray(value)) {
      const cleanedArray = value
        .map((v, i) => clean(v, `${path}[${i}]`))
        .filter(v => v !== undefined);

      return cleanedArray.length ? cleanedArray : undefined;
    }

    if (_.isPlainObject(value)) {
      const result = {};

      Object.entries(value).forEach(([key, val]) => {
        if (removeSet.has(key)) return;

        const cleanedVal = clean(val, path ? `${path}.${key}` : key);

        if (cleanedVal === undefined) return;

        // remove false values
        if (cleanedVal === false) return;

        result[key] = cleanedVal;
      });

      return Object.keys(result).length ? result : undefined;
    }

    // primitives
    if (value === false) return undefined;

    return value;
  };

  return clean(obj) || {};
};